module.exports = __webpack_public_path__ + "media/images/upload-image-314b5b42ee5b07098588d67d8dec0b3c.jpg";